import AiSearchProfileDialog from '../AiSearchProfilePopout/AiSearchProfileDialog';
import EmailCandidateDialog from './Outreach/EmailCandidateFormDialog/EmailCandidateDialog';
import LinkedInMessageDialog from './Outreach/LinkedInMessage/LinkedInMessageDialog';
import ShortlistedHeader from './ShortlistedHeader';
import ShortlistedList from './ShortlistedList';
import { ShortlistedTableContext, useShortlistedTableContextProvider } from './utils/ShortlistedTableContext';

const ShortlistedPageContent = () => {
    return (
        <ShortlistedTableContext.Provider value={useShortlistedTableContextProvider()}>
            <AiSearchProfileDialog />
            <LinkedInMessageDialog />
            <EmailCandidateDialog />
            <ShortlistedHeader />
            <ShortlistedList />
        </ShortlistedTableContext.Provider>
    );
};

export default ShortlistedPageContent;
